import { FC, useEffect } from "react";
import Logo from "shared/Logo/Logo";
import Navigation from "shared/Navigation/Navigation";
import SearchDropdown from "./DropDowns/SearchDropdown";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import HeroSearchForm2MobileFactory from "components/HeroSearchForm2Mobile/HeroSearchForm2MobileFactory";
import AvatarDropdown from "./DropDowns/AvatarDropdown";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentHost, setHost } from "application/features/host/hostSlice";
import { Host } from "data/types/host";
import { useGetMeQuery } from "application/features/host/hostApiSlice";
import ChangeLanguage from "components/ChangeLanguage/ChangeLanguage";
import { useTranslation } from "react-i18next";

export interface MainNav1Props {
  className?: string;
}

const MainNav1: FC<MainNav1Props> = ({ className = "" }) => {

  const { t, ready } = useTranslation("translation");
  const { data, isLoading } = useGetMeQuery({})
  const host: Host = useSelector(selectCurrentHost);

  const dispatch = useDispatch()

  useEffect(() => {
    if (!isLoading && data) {
      dispatch(setHost({ ...data }))
    }
  }, [isLoading, data])

  if (!ready) return null;
  
  return (
    <div className={`nc-MainNav1 relative z-10 ${className}`}>
      <div className="px-4 lg:container py-4 lg:py-5 relative flex justify-between items-center">
        <div className="hidden md:flex justify-start flex-1 items-center space-x-4 sm:space-x-10">
          <Logo />
          <Navigation />
        </div>

        <div className="lg:hidden flex-[3] max-w-lg !mx-auto md:px-3">
          <HeroSearchForm2MobileFactory />
        </div>

        <div className="hidden md:flex flex-shrink-0 items-center justify-end flex-1 lg:flex-none text-neutral-700 dark:text-neutral-100">
          <div className="hidden lg:flex items-center space-x-0.5">
            {
              host &&
              <ButtonPrimary href="/host/new-listing/">{t("translation:navbar.uploadServiceText")}</ButtonPrimary>
            }
            <SearchDropdown />
            <div className="px-1" />
            {
              host ?
                <AvatarDropdown url={host.host_uuid ? host.avatar : ""} />
                :
                <ButtonPrimary href="/login">{t("translation:navbar.loginButtonText")}</ButtonPrimary>
            }
            <div className="px-1" />
            {/* <ChangeLanguage /> */}
          </div>
        </div>

      </div>
    </div>
  );
};

export default MainNav1;
